"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.traceTranscriptFilterDefinition = void 0;
const filterFields_1 = require("./filterFields");
/** One observation must satisfy every condition to select its whole trace. */
const traceTranscriptFilterColumns = [
    filterFields_1.evalFilterFields.traceName,
    filterFields_1.evalFilterFields.userId,
    filterFields_1.evalFilterFields.sessionId,
    filterFields_1.evalFilterFields.tags,
    filterFields_1.evalFilterFields.metadata,
    filterFields_1.evalFilterFields.name,
    filterFields_1.evalFilterFields.type,
    filterFields_1.evalFilterFields.environment,
    filterFields_1.evalFilterFields.version,
    filterFields_1.evalFilterFields.release,
    filterFields_1.evalFilterFields.level,
    filterFields_1.evalFilterFields.statusMessage,
    filterFields_1.evalFilterFields.providedModelName,
    filterFields_1.evalFilterFields.promptName,
    filterFields_1.evalFilterFields.experimentId,
    filterFields_1.evalFilterFields.experimentName,
    filterFields_1.evalFilterFields.experimentDatasetId,
    filterFields_1.evalFilterFields.isRootObservation,
    filterFields_1.evalFilterFields.isExperimentItemRootSpan,
];
/** Restrict operators to predicates exposed for matching a single observation. */
exports.traceTranscriptFilterDefinition = {
    columns: traceTranscriptFilterColumns,
    operators: {
        string: ["=", "contains", "starts with", "ends with", "is not empty"],
        stringOptions: ["any of"],
        arrayOptions: ["any of", "all of"],
        stringObject: ["=", "contains", "starts with", "ends with", "is set"],
        boolean: ["="],
        null: [],
    },
};
